var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewIconReplyConfirmed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0l4.578 3.38H28l-.004 9.595c0 8.69-5.935 15.98-14.003 18.136C5.938 28.955.005 21.665.005 12.975L0 3.38h9.424L14 0zm6.306 10.58l-7.982 7.688-3.63-3.495-1.388 1.44 5.019 4.833 9.369-9.026-1.388-1.44z",
    transform: "translate(-60 -395) translate(20 75) translate(20 298) translate(20 22)"
  })));
}
export default SvgReviewIconReplyConfirmed;